import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import Button from '@magento/venia-ui/lib/components/Button';
import RadioGroup from '@magento/venia-ui/lib/components/RadioGroup';
import Radio from '@magento/venia-ui/lib/components/RadioGroup/radio';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import { TextArea } from '../../..';
import { useFormState } from 'informed';
import defaultClasses from './tearsheetForm.module.css';
import { useStyle } from '@magento/venia-ui/lib/classify';
import projectFormCSS from 'src/overrides/venia-ui/components/WishlistPage/DownloadProjectModal/ProjectForm/projectForm.module.css';

var TearsheetForm = function TearsheetForm(_ref) {
  var closeDrawer = _ref.closeDrawer,
      propClasses = _ref.classes;
  var classes = useStyle(projectFormCSS, defaultClasses, propClasses);

  var _useFormState = useFormState(),
      values = _useFormState.values;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes.body
  }, React.createElement("div", {
    className: "mb-6"
  }, React.createElement("h4", null, "Select an option below"), React.createElement(RadioGroup, {
    field: 'price',
    classes: {
      root: 'flex justify-between flex-col'
    },
    initialValue: 'Hide pricing'
  }, React.createElement("label", {
    className: "my-6"
  }, React.createElement(Radio, {
    value: "Hide pricing",
    className: "mr-3",
    checked: true,
    id: "hide-pricing",
    "aria-label": "Hide pricing"
  })), React.createElement("label", {
    className: "mb-6"
  }, React.createElement(Radio, {
    value: "Display pricing",
    className: "mr-3",
    id: "display-pricing"
  })), isUserSignedIn ? React.createElement(React.Fragment, null, React.createElement("label", {
    className: "mb-6"
  }, React.createElement(Radio, {
    value: "Custom Markup pricing",
    className: "mr-3",
    id: "custom-markup-radio",
    "aria-label": "Custom Markup pricing"
  })), React.createElement("label", {
    className: "sr-only",
    htmlFor: "custom-markup-pricing"
  }, "Custom Markup pricing"), React.createElement(TextInput, {
    disabled: (values === null || values === void 0 ? void 0 : values.price) !== 'Custom Markup pricing',
    field: 'pricing',
    type: "number",
    id: "custom-markup-pricing",
    placeholder: 'Enter Markup ex. 2.65',
    onKeyDown: function onKeyDown(evt) {
      return ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault();
    }
  })) : null)), React.createElement("div", {
    className: classes.notesWrapper
  }, React.createElement("label", {
    className: "sr-only",
    htmlFor: "note"
  }, "Note"), React.createElement(TextArea, {
    autoComplete: "note",
    field: "note",
    id: "note" // validate={isRequired}
    ,
    placeholder: 'Note',
    initialValue: '',
    maxLength: 50
  }))), React.createElement("div", {
    className: classes.actionsWrapper
  }, React.createElement(Button, {
    priority: "normal",
    onClick: closeDrawer,
    "aria-label": "Cancel"
  }, "CANCEL"), React.createElement(Button, {
    priority: "low",
    type: "submit",
    "aria-label": "Download"
  }, "DOWNLOAD")));
};

export default TearsheetForm;